// import { mapActions } from 'vuex'
// import Vue from 'vue/types/vue';

export default {
  props: {
    control: {
      required: true,
      type: Object
    }
  },
  methods: {
  //   ...mapActions('Questionnaires', [
  //     'updateControl'
  //   ]),
    onEditControl (field, value) {
      this.$emit('update-control', { field, value })
    }
  }
}
